import React, { Component } from 'react';
import {Tooltip,Icon} from '@shopify/polaris';
import {
    QuestionMarkMajor,
  } from '@shopify/polaris-icons';
class Tooltips extends Component {
    render() {
        return (
            <div>
             <Tooltip content={this.props.text}>
             <Icon source={QuestionMarkMajor} color="base" />
            </Tooltip>   
            </div>
        );
    }
}

export default Tooltips;
